aptis.virtualReality.engine.ConfigUpdater = new Class({

	/**
	 * @var {Number}
	 */
	CURRENT_VERSION: 2,

	/**
	 * @param {Object} config
	 */
	update: function(config) {
		const configVersion = config.version || 1;

		if (configVersion === 1) {
			this._update1To2(config);
		}
	},

	/**
	 * @var {Object} config
	 * @private
	 */
	_update1To2: function(config) {
		const oldRules = config.visibilityRules;
		delete config.visibilityRules;
		config.rules = {};
		config.rules.visibleIf = oldRules;
	},
});
